import { BottomContent } from './BottomContent/BottomContent';

export const Albums = {
    BottomContent,
};
